import TileOneImage from 'images/zrmUpsell/tile-1-image.webp';
import TileOneOverlay from 'images/zrmUpsell/tile-1-overlay.webp';
import TileTwoImage from 'images/zrmUpsell/tile-2-image.webp';
import TileTwoOverlay from 'images/zrmUpsell/tile-2-overlay.webp';
import TileThreeImage from 'images/zrmUpsell/tile-3-image.webp';
import TileThreeOverlay from 'images/zrmUpsell/tile-3-overlay.webp';
import TileFourImage from 'images/zrmUpsell/tile-4-image.webp';
import TileFourOverlay from 'images/zrmUpsell/tile-4-overlay.webp';
import TileFiveImage from 'images/zrmUpsell/tile-5-image.webp';

export default {
  TileOneImage,
  TileOneOverlay,
  TileTwoImage,
  TileTwoOverlay,
  TileThreeImage,
  TileThreeOverlay,
  TileFourImage,
  TileFourOverlay,
  TileFiveImage,
};
